import { AxiosResponse } from "axios";
import { axiosInstance, OptionValues } from "./common";

interface TenantOptionsResponse {
    options_values: OptionValues[]
}

const TenantOptionsAPI = {
    get : async () => {
        try {
            const response: AxiosResponse<TenantOptionsResponse> = await axiosInstance.get('/v1/tenant-options');
            return response.data.options_values;
        } catch(error) {
            console.error(error)
            return [];
        }
    }
}

export default TenantOptionsAPI;